import { render, staticRenderFns } from "./SmsTemplateDetail.vue?vue&type=template&id=f39c3d02&scoped=true&"
import script from "./SmsTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./SmsTemplateDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39c3d02",
  null
  
)

export default component.exports